// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"67":"9a536e73","515":"72934c3f"}[chunkId] + ".js";
};